<template>
  <div class="home-page-4">
    <div class="box-title">订单数据</div>
    <div class="page4-content">
      <div class="page2-content-list">
        <el-image
          :src="require('@/assets/images/jryj.png')"
          class="page4-left-image"
        ></el-image>
        <div class="page4-right">
          <div class="list-top">
            <span class="list-txt">今日成功抢单数</span>
          </div>
          <div class="list-num">
            <span>{{ $q(detail.todayNum) }}</span>
            <!--            <el-image-->
            <!--              :src="require('@/assets/images/arrow_right.png')"-->
            <!--              class="arrow-image"-->
            <!--            ></el-image>-->
          </div>
        </div>
      </div>
      <div class="page2-content-list">
        <el-image
          :src="require('@/assets/images/dyyj.png')"
          class="page4-left-image"
        ></el-image>
        <div class="page4-right">
          <div class="list-top">
            <span class="list-txt">当月成功抢单数</span>
          </div>
          <div class="list-num">
            <span>{{ $q(detail.monthNum) }}</span>
            <!--            <el-image-->
            <!--              :src="require('@/assets/images/arrow_right.png')"-->
            <!--              class="arrow-image"-->
            <!--            ></el-image>-->
          </div>
        </div>
      </div>
      <div class="page2-content-list">
        <el-image
          :src="require('@/assets/images/lszsr.png')"
          class="page4-left-image"
        ></el-image>
        <div class="page4-right">
          <div class="list-top">
            <span class="list-txt">总计成功抢单数</span>
          </div>
          <div class="list-num">
            <span>{{ $q(detail.totalNum) }}</span>
            <!--            <el-image-->
            <!--              :src="require('@/assets/images/arrow_right.png')"-->
            <!--              class="arrow-image"-->
            <!--            ></el-image>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderCount } from "@/views/HomePage/api";

export default {
  name: "DataOverview",
  components: {},
  data() {
    return {
      detail: {
        monthNum: 0,
        todayNum: 0,
        totalNum: 0,
      },
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      getOrderCount().then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.home-page-4 {
  width: 100%;
  height: 1.8rem;
  background-color: #ffffff;
  border-radius: 0.08rem;
  margin-bottom: 0.16rem;
  padding: 0.2rem 0.16rem 0;
  box-sizing: border-box;
  .box-title {
    font-weight: 500;
    font-size: 0.16rem;
    color: #1f2329;
    padding-bottom: 0.16rem;
  }
  .page4-content {
    display: flex;
    .page2-content-list {
      width: 33.33%;
      border-radius: 0.12rem;
      border: 0.01rem solid #edeef1;
      padding: 0.2rem 0.16rem;
      box-sizing: border-box;
      margin-right: 0.16rem;
      display: flex;
      align-items: center;
      .page4-left-image {
        width: 0.48rem;
        height: 0.48rem;
        flex-shrink: 0;
        margin-right: 0.16rem;
      }
      .page4-right {
        flex: 1;
      }
      .list-top {
        display: flex;
        align-items: center;
        .top-image {
          width: 0.16rem;
          height: 0.16rem;
        }
        .list-txt {
          font-weight: 400;
          font-size: 0.14rem;
          color: #69718c;
          padding-left: 0.04rem;
          line-height: 0.2rem;
        }
      }
      .list-num {
        width: 100%;
        font-weight: 500;
        font-size: 0.26rem;
        color: #212533;
        font-family: pm, serif;
        padding-top: 0.14rem;
        line-height: 0.34rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .arrow-image {
          width: 0.26rem;
          height: 0.16rem;
        }
      }
    }
    .page2-content-list:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}
</style>
